import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { LivePayload } from 'src/services/live'

import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { useUser } from 'src/hook/useUser'
import { useGetWebinarsQuery } from '../useGetWebinarsQuery'

const useWebinars = () => {
  const { authStatus } = useUser()
  const { idCommunity } = useParams()

  const {
    data: webinarsData,
    isLoading: isLoadingWebinarsQuery,
    ...rest
  } = useGetWebinarsQuery({
    communityId: Number(idCommunity),
    enabled: Number(idCommunity) > 0 && authStatus === AuthStatus.AUTHENTICATED
  })

  const webinars = useMemo(
    () =>
      webinarsData?.pages?.reduce((pages, page) => {
        if (!page?.data?.length) return pages

        return [...pages, ...page.data]
      }, [] as LivePayload[]),
    [webinarsData?.pages]
  )

  return {
    webinars,
    isLoading: isLoadingWebinarsQuery,
    ...rest
  }
}

export default useWebinars
